import { Datagrid, DatagridProps, DatagridConfigurable, DatagridConfigurableProps } from "react-admin";
import { Theme, styled } from "@mui/material";

// Shared styles as a function
const datagridStyles = (theme: Theme, fixedLayout?: boolean) => ({
  border: "none",
  overflow: "visible",

  // Apply border radius to the table itself
  "& .MuiTable-root": {
    borderRadius: theme.spacing(1.5),
    overflow: "hidden", // Clip the table content to the rounded corners
    ...(fixedLayout && {
      tableLayout: "fixed",
      width: "100%",
    }),
  },

  // Header styling
  "& .RaDatagrid-thead": {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  "& .RaDatagrid-headerCell": {
    fontWeight: 600,
    textTransform: "none",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    backgroundColor: "transparent",
  },

  // Row styling
  "& .RaDatagrid-row": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    transition: "background-color 0.15s ease",

    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },

    "&:last-child": {
      borderBottom: "none",
    },
  },

  // Cell styling
  "& .RaDatagrid-rowCell": {
    padding: `${theme.spacing(1.25)} ${theme.spacing(1.5)}`,
    color: theme.palette.text.primary,
  },

  // Remove the clickable row cursor unless it's actually clickable
  "& .RaDatagrid-clickableRow": {
    cursor: "pointer",
  },
});

export const StyledDatagrid = styled(Datagrid, {
  shouldForwardProp: (prop) => prop !== "fixedLayout",
})<DatagridProps & { fixedLayout?: boolean }>(({ theme, fixedLayout }) => datagridStyles(theme, fixedLayout));

export const StyledDatagridConfigurable = styled(DatagridConfigurable, {
  shouldForwardProp: (prop) => prop !== "fixedLayout",
})<DatagridConfigurableProps & { fixedLayout?: boolean }>(({ theme, fixedLayout }) =>
  datagridStyles(theme, fixedLayout)
);
